// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import { VueHammer } from 'vue2-hammer'
import store from './store'
import VueLazyload from 'vue-lazyload'
import Vuetify from 'vuetify'

Vue.use(VueHammer)
Vue.use(BootstrapVue)
Vue.use(VueLazyload)
Vue.use(Vuetify)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify: new Vuetify({
  }),
  template: '<App/>',
  components: {
    App
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js